/**
 * Base path of the web admin.
 *
 * Spec `2026-07-21-tgbot-admin-menu-restoration`, Phase 1 Step 8: the admin
 * used to live at the guessable `/admin`. It was relocated to a non-standard
 * path so the admin surface is not trivially discoverable by scanning.
 *
 * This is **obscurity, not access control** — the real gate is the backend
 * role check (`user_roles`, `get_admin_user`). Changing this constant only
 * changes where the screens are mounted; it grants nothing on its own.
 *
 * Defined once and imported everywhere so a future rename cannot leave a
 * dangling in-app link behind.
 *
 * NOTE: unrelated to the API's `/admin/*` endpoints, which keep their paths.
 */
export const ADMIN_BASE_PATH = '/AdminPanelDashboardv1';

export const ADMIN_DASHBOARD_PATH = `${ADMIN_BASE_PATH}/dashboard`;
export const ADMIN_USERS_PATH = `${ADMIN_BASE_PATH}/users`;
export const ADMIN_STARS_RATE_PATH = `${ADMIN_BASE_PATH}/stars-rate`;
export const ADMIN_MIRROR_STARS_PATH = `${ADMIN_BASE_PATH}/mirror-stars`;
